import React from 'react';
import {connect} from 'react-redux';
import {Route, Redirect} from 'react-router-dom';

const stateToProps = state => {
  return {
    user: state.user,
  };
};

const PrivateRoute = ({component: Component, user, allowedUserStates = ['OK'], ...rest}) => (
  <Route
    {...rest}
    render={props => {
      if (!user || Object.keys(user).length === 0) {
        return (
          <Redirect
            to={{
              pathname: '/login-check',
              state: {origin: props.location},
            }}
          />
        );
      } else if (!allowedUserStates.includes(user.pcBangStatus)) {
        alert(
          '접근 권한이 없습니다.\n관리자에게 문의하세요.\n(승인 대기 중인 회원의 경우 승인 이후에 사용 가능합니다.)'
        );
        return (
          <Redirect
            to={{
              pathname: '/',
              state: {origin: props.location},
            }}
          />
        );
      } else {
        return <Component {...props} />;
      }
    }}
  />
);

export default connect(stateToProps, null, null, {pure: false})(PrivateRoute);
